//零星采购管理
export default [
//需求计划编制
{
  path: 'demandPlanEdit',
  name: 'demandPlanEdit',
  component: function component() {
    return import('@/views/materialManage/demandPlan/edit');
  }
},
//需求计划列表
{
  path: 'demandPlanList',
  name: 'demandPlanList',
  component: function component() {
    return import('@/views/materialManage/demandPlan/list');
  }
},
//需求计划详情
{
  path: 'demandPlanDetail',
  name: 'demandPlanDetail',
  component: function component() {
    return import('@/views/materialManage/demandPlan/detail');
  }
},
//需求计划成功页面demandPlan
{
  path: 'demandPlanSuccess',
  name: 'demandPlanSuccess',
  component: function component() {
    return import('@/views/materialManage/demandPlan/success');
  }
},
//计划编制
{
  path: 'materialBidPlanEdit',
  name: 'materialBidPlanEdit',
  component: function component() {
    return import('@/views/materialManage/plan/edit');
  }
},
// 计划审批统计
{
  path: 'materialBidPlanList',
  name: 'materialBidPlanList',
  component: function component() {
    return import('@/views/materialManage/plan/list');
  }
},
//成功页面
{
  path: 'materialBidPlanSuccess',
  name: 'materialBidPlanSuccess',
  component: function component() {
    return import('@/views/materialManage/plan/success');
  }
},
//流程中页面
{
  path: 'materialBidPlanDetail',
  name: 'materialBidPlanDetail',
  component: function component() {
    return import('@/views/materialManage/plan/detail');
  }
},
//立项审批统计
{
  path: 'materialBidList',
  name: 'materialBidList',
  component: function component() {
    return import('@/views/materialManage/bid/list');
  }
},
//立项编制
{
  path: 'materialBidAdd',
  name: 'materialBidAdd',
  component: function component() {
    return import('@/views/materialManage/bid/add');
  }
}, {
  path: 'materialBidUpdate',
  name: 'materialBidUpdate',
  component: function component() {
    return import('@/views/materialManage/bid/update');
  }
},
//  立项详情
{
  path: 'materialBidDetail',
  name: 'materialBidDetail',
  component: function component() {
    return import('@/views/materialManage/bid/detail');
  }
}, {
  path: 'materialSupplierRecordDetail',
  name: 'materialSupplierRecordDetail',
  component: function component() {
    return import('@/views/materialManage/supplier/recordDetail');
  }
}, {
  path: 'materialBidSuccess',
  name: 'materialBidSuccess',
  component: function component() {
    return import('@/views/materialManage/bid/success');
  }
}, {
  path: 'materialBidReviewList',
  name: 'materialBidReviewList',
  component: function component() {
    return import('@/views/materialManage/review/list');
  }
}, {
  path: 'materialBidReviewSuccess',
  name: 'materialBidReviewSuccess',
  component: function component() {
    return import('@/views/materialManage/review/success');
  }
}, {
  path: 'materialBidReviewDetail',
  name: 'materialBidReviewDetail',
  component: function component() {
    return import('@/views/materialManage/review/detail');
  }
}, {
  path: 'materialExaminationList',
  name: 'materialExaminationList',
  component: function component() {
    return import('@/views/materialManage/supplier/examination/list');
  }
}, {
  path: 'materialExaminationDetail',
  name: 'materialExaminationDetail',
  component: function component() {
    return import('@/views/materialManage/supplier/examination/detail');
  }
}, {
  path: 'materialSupplierList',
  name: 'materialSupplierList',
  component: function component() {
    return import('@/views/materialManage/supplier/list');
  }
}, {
  path: 'materialSupplierDetail',
  name: 'materialSupplierDetail',
  component: function component() {
    return import('@/views/materialManage/supplier/detail');
  }
}, {
  path: 'materialSupplierNewDetail',
  name: 'materialSupplierNewDetail',
  component: function component() {
    return import('@/views/materialManage/supplier/newDetail');
  }
}, {
  path: 'materialSupplierSuccess',
  name: 'materialSupplierSuccess',
  component: function component() {
    return import('@/views/materialManage/supplier/success');
  }
},
// 成交价数据库
{
  path: 'materialDealOver',
  name: 'materialDealOver',
  component: function component() {
    return import('@/views/materialManage/dealOver/list');
  }
}, {
  path: 'materialDealOverAvgPrice',
  name: 'materialDealOverAvgPrice',
  component: function component() {
    return import('@/views/materialManage/dealOver/avgPriceList');
  }
},
//采购报表
{
  path: 'materialReport',
  name: 'materialReport',
  component: function component() {
    return import('@/views/materialManage/reportManage/homeList');
  }
},
// 采购数据分析表
{
  path: 'materialAnalyseList',
  name: 'materialAnalyseList',
  component: function component() {
    return import('@/views/materialManage/reportManage/analyseList');
  }
},
//采购明细汇总统计表
{
  path: 'materialSummaryList',
  name: 'materialSummaryList',
  component: function component() {
    return import('@/views/materialManage/reportManage/summaryList');
  }
},
//采购明细汇总统计表
{
  path: 'materialExecuteContractReport',
  name: 'materialExecuteContractReport',
  component: function component() {
    return import('@/views/materialManage/reportManage/executeContractList');
  }
},
// 总局看到的零星采购情况统计表
{
  path: 'materialFormDept',
  name: 'materialFormDept',
  component: function component() {
    return import('@/views/materialManage/reportManage/deptList');
  },
  props: function props(route) {
    return {
      data: route.params.data
    };
  }
},
// 分局看到的零星采购情况统计表
{
  path: 'materialFormBranch',
  name: 'materialFormBranch',
  component: function component() {
    return import('@/views/materialManage/reportManage/branchList');
  },
  props: function props(route) {
    return {
      data: route.params.data
    };
  }
},
// 项目部看到的零星采购情况统计表
{
  path: 'materialFormProject',
  name: 'materialFormProject',
  component: function component() {
    return import('@/views/materialManage/reportManage/projectList');
  },
  props: function props(route) {
    return {
      data: route.params.data
    };
  }
},
// 项目部看到的零星采购情况统计表编制
{
  path: 'materialFormProjectAdd',
  name: 'materialFormProjectAdd',
  component: function component() {
    return import('@/views/materialManage/reportManage/projectAdd');
  }
},
// 项目部看到的零星采购情况统计表详情
{
  path: 'materialFormProjectDetail',
  name: 'materialFormProjectDetail',
  component: function component() {
    return import('@/views/materialManage/reportManage/projectDetail');
  }
},
// 项目部看到的零星采购情况统计表待编制
{
  path: 'materialFormProjectEdit',
  name: 'materialFormProjectEdit',
  component: function component() {
    return import('@/views/materialManage/reportManage/projectEdit');
  }
},
// 项目部看到的零星采购情况统计成功页面
{
  path: 'materialFormProjectSuccess',
  name: 'materialFormProjectSuccess',
  component: function component() {
    return import('@/views/materialManage/reportManage/success');
  }
},
// 项目部看到的零星采购情况统计成功页面
{
  path: 'materialSituationList',
  name: 'materialSituationList',
  component: function component() {
    return import('@/views/materialManage/reportManage/situationList');
  }
}, {
  path: 'materialSituationListV2',
  name: 'materialSituationListV2',
  component: function component() {
    return import('@/views/materialManage/reportManage/situationListV2');
  }
},
//立项审批统计
{
  path: 'priceApproveList',
  name: 'priceApproveList',
  component: function component() {
    return import('@/views/materialManage/approve/list');
  }
}, {
  path: 'materialApproveDetail',
  name: 'materialApproveDetail',
  component: function component() {
    return import('@/views/materialManage/approve/detail');
  }
}, {
  path: 'materialDealExamineList',
  name: 'materialDealExamineList',
  component: function component() {
    return import('@/views/materialManage/examine/list');
  }
}, {
  path: 'materialNotificationExamineList',
  name: 'materialNotificationExamineList',
  component: function component() {
    return import('@/views/materialManage/examine/notificationList');
  }
}, {
  path: 'materialDealExamineDetail',
  name: 'materialDealExamineDetail',
  component: function component() {
    return import('@/views/materialManage/examine/detail');
  }
}, {
  path: 'materialNotificationDetail',
  name: 'materialNotificationDetail',
  component: function component() {
    return import('@/views/materialManage/examine/notificationDetail');
  }
},
//成功页面
{
  path: 'materialApproveSuccessl',
  name: 'materialApproveSuccessl',
  component: function component() {
    return import('@/views/materialManage/approve/success');
  }
},
//成功页面
{
  path: 'materialDealExamineSuccess',
  name: 'materialDealExamineSuccess',
  component: function component() {
    return import('@/views/materialManage/examine/success');
  }
},
//成功页面
{
  path: 'materialNotificationSuccess',
  name: 'materialNotificationSuccess',
  component: function component() {
    return import('@/views/materialManage/examine/notificationSuccess');
  }
}, {
  path: 'materialContract',
  name: 'materialContract',
  component: function component() {
    return import('@/views/materialManage/contract/index');
  }
}, {
  path: 'materialContractReviewList',
  name: 'materialContractReviewList',
  component: function component() {
    return import('@/views/materialManage/contract/list');
  }
}, {
  path: 'materialContractSuccess',
  name: 'materialContractSuccess',
  component: function component() {
    return import('@/views/materialManage/contract/success');
  }
}, {
  path: 'materialContractEdit',
  name: 'materialContractEdit',
  component: function component() {
    return import('@/views/materialManage/contract/edit');
  }
}, {
  path: 'materialContractDetail',
  name: 'materialContractDetail',
  component: function component() {
    return import('@/views/materialManage/contract/detail');
  }
}, {
  path: 'materialContractSignList',
  name: 'materialContractSignList',
  component: function component() {
    return import('@/views/materialManage/contract/signList');
  }
}, {
  path: 'materialContractSignDetail',
  name: 'materialContractSignDetail',
  component: function component() {
    return import('@/views/materialManage/contract/signDetail');
  }
}, {
  path: 'materialContractSignEdit',
  name: 'materialContractSignEdit',
  component: function component() {
    return import('@/views/materialManage/contract/signEdit');
  }
}, {
  path: 'materialContractLedgerList',
  name: 'materialContractLedgerList',
  component: function component() {
    return import('@/views/materialManage/contract/ledgerList');
  }
}, {
  path: 'materialOfflineRecord',
  name: 'materialOfflineRecord',
  component: function component() {
    return import('@/views/materialManage/offlineRecord/index');
  }
}, {
  path: 'materialOfflineEdit',
  name: 'materialOfflineEdit',
  component: function component() {
    return import('@/views/materialManage/offlineRecord/add');
  }
}, {
  path: 'materialOfflineDetail',
  name: 'materialOfflineDetail',
  component: function component() {
    return import('@/views/materialManage/offlineRecord/detail');
  }
},
//  采购沟通平台
{
  path: 'materialMessage',
  name: 'materialMessage',
  component: function component() {
    return import('@/views/materialManage/materialMessage/index');
  }
},
//  
{
  path: 'materialArchivesList',
  name: 'materialArchivesList',
  component: function component() {
    return import('@/views/materialManage/archives/list');
  }
}, {
  path: 'materialFileManageList',
  name: 'materialFileManageList',
  component: function component() {
    return import('@/views/materialManage/materialFileManage/list');
  }
}, {
  path: 'returnGoodsList',
  name: 'returnGoodsList',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnGoods/list');
  }
}, {
  path: 'returnOutBillEdit',
  name: 'returnOutBillEdit',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnGoods/add');
  }
}, {
  path: 'returnStockList',
  name: 'returnStockList',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnStock/list');
  }
}, {
  path: 'returnInStorageEdit',
  name: 'returnInStorageEdit',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnStock/add');
  }
}, {
  path: 'returnInStorageDetail',
  name: 'returnInStorageDetail',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnStock/detail');
  }
}, {
  path: 'returnOutBillDetail',
  name: 'returnOutBillDetail',
  component: function component() {
    return import('@/views/stockManagement/materialRefund/returnGoods/detail');
  }
}, {
  path: 'purchaseContractExecution',
  name: 'purchaseContractExecution',
  component: function component() {
    return import('@/views/materialManage/reportManage/purchaseContractDynamic/index');
  }
}];